import http from '../http-common.js';
import * as constants from '../util/constants';

class AuthService {
  async login(user) {
    try {
      const response = await http
      .post(constants.LOGIN_URL, {
        username: user.username,
        password: user.password
      });
      if (response.data.entity.accessToken) {
        localStorage.setItem('authorization', JSON.stringify(response.data.entity));
      }
      return response.data.entity;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('authorization');
  }

  register(user) {
    return http.post(constants.SIGNUP_URL, {
      name: user.name,
      username: user.username,
      email: user.email,
      password: user.password
    });
  }

  async getCurrentUser() {
    let currentUser = null;
    try {
      const response = await http.get(constants.PROFILE_URL);
      if (response.data.success) {
        currentUser = await response.data.entity;
      }
    } catch (e) {
      console.error(e);
    }
    return currentUser;
  }

  async isTokenValid(params) {
    let isTokenValid = false;
    try {
      const response = await http.get(constants.VALIDATE_TOKEN_URL, {params});
      if (response.data.success) {
        isTokenValid = response.data.entity;
      }
    } catch (e) {
      console.error(e);
    }
    return isTokenValid;
  }

   changePassword(data) {
    return http.post(constants.CHANGE_PASSWORD_URL, data);
  }
}

export default new AuthService();